<template>
  <component
    :is="transaction?.getFormAccountId1()"
    v-if="transaction && useExisting"
    :focus-on-load="focusNameOnLoad"
    :instance="transaction"
    :size
    remove-linked-accounts
    disallow-create
    label=""
    tabindex="1"
  />
  <template v-else>
    <component
      :is="account.getFormName()"
      :focus-on-load="focusNameOnLoad"
      :instance="account"
      :size
      label="Name"
      placeholder="Ex. John Smith Trust"
      tabindex="1"
    />
    <component
      :is="account.getFormType()"
      :focus-on-load="focusTypeOnLoad"
      :instance="account"
      :size
      :restrictions
      label="Type"
      tabindex="2"
    />
  </template>
</template>

<script setup lang="ts">
import { computed, inject, watch } from 'vue'

import { AssetClass, InputSize, TransactionClass } from '@types'

import { ASSET_FIELD } from '@/const'

type Props = {
  transaction?: TransactionClass
  account: AssetClass
  useExisting?: boolean
}

const props = defineProps<Props>()

defineOptions({ inheritAttrs: false })

const size = inject<InputSize>('size')

const restrictions = computed(
  () => props.transaction?.settings?.entries[0].account?.includes,
)

const focusNameOnLoad = computed(
  () => !props.account.field(ASSET_FIELD.NAME).value,
)

const focusTypeOnLoad = computed(
  () => !focusNameOnLoad.value && !props.account.field(ASSET_FIELD.TYPE).value,
)

watch(
  () => props.account?.field(ASSET_FIELD.NAME).value,
  value => {
    props.account && (props.account.field(ASSET_FIELD.TICKER).value = value)
  },
)
</script>
